<button mat-fab color="primary" 
matTooltip="Return to Parker Profile Home/Search"
aria-label="Return to Parker Profile Home/Search" 
(click)="onRouteToParkersHome()"
style="margin-top:20px;margin-left:20px;">
<mat-icon>arrow_back</mat-icon>
</button>
<br />

<div  style="margin-left:30px;margin-top:30px" >
    <span class="lanai-page-title">Parker Profile Import for Lot Number: {{currentLotNumber}}</span>
</div>


<!-- <div class="container-full"> -->

<mat-tab-group style="margin-top:30px;">
    <mat-tab >
        <ng-template mat-tab-label>
            <mat-icon class="example-tab-icon mr-2">people</mat-icon>
            <span style="margin-left: 5px">
                Profiles to Import for Lot Number {{currentLotNumber}}
            </span>
        </ng-template>
       
            <div  style="margin-bottom:30px;margin-top:20px;">
                <div style="margin-left:30px;">
                    <button type="button" (click)="onValidateParkerProfiles()" class="btn btn-primary ace-blue" style="margin-left:0px;color:white;"[disabled]="profileData.length == 0">Validate Parker Profile(s)</button>
                    <button type="button" [disabled]="validationErrors.length > 0 || profileValidationCompleted == false || importInProgress" (click)="SaveParkerProfiles()"  class="btn btn-primary ace-blue" style="margin-left:20px;color:white;" >Import Parker Profile(s)</button>
                    <button type="button" (click)="ClearParkerProfiles()"  class="btn btn-primary ace-blue" style="margin-left:20px;color:white;" >Clear Parker Profile(s)</button>
                    <!-- <button type="button" (click)="LogProfileDataArray()"  class="btn btn-primary ace-blue" style="margin-left:20px;color:white;" >Log</button> -->
                    <a href="../../../../assets/ace-templates/parker-import-template.xlsx" class="btn btn-primary ace-blue" role="button" aria-disabled="true" style="margin-left:15%;">Download Parker Import Template - Excel Format</a>
                </div>
            

            <div class="row mt-3" *ngIf="isValidating" style="margin-left:25px;">
                <div class="col-10">
                    <mat-spinner [diameter]="30"></mat-spinner>
                    <span style="font-size:16px;color: black;margin-left:10px;margin-top:10px">Validating Import Data.  Stand by</span>
                </div>
                </div>
            <div class="row mt-3" *ngIf="importErrorsExist">
                <div class="col-10">
                    <span class="material-icons error-icon ml-5"  style="position: relative; top:3px;margin-left:50px;">
                        warning
                    </span>
                    <span style="font-size:16px;color: red;margin-left:5px;">{{parkerSuccessResults.length}} Parker Profile(s) were submitted successfully, but some profiles were not submitted.  Please review the queued Parker Profiles and submit again.  If errors continue please contact your system administrator.</span>
                </div>
            </div>
            <!-- <div class="row mt-3" *ngIf="importErrorsExist">
                <div class="col-10">
                    <span class="material-icons error-icon ml-5"  style="position: relative; top:3px;margin-left:50px;">
                        warning
                    </span>
                    <span style="font-size:16px;color: red;margin-left:5px;">{{parkerSuccessResults.length}} Parker Profile(s) were submitted successfully, but some profiles were not submitted.  Please review the queued Parker Profiles and submit again.  If errors continue please contact your system administrator.</span>
                </div>
            </div> -->
            <div class="row mt-3" *ngIf="validationErrors.length > 0">
                <div class="col-10">
                    <span class="material-icons error-icon" style="position: relative; top:3px;margin-left:50px;">
                        warning
                    </span>
                    <span style="font-size:16px;color: red;margin-left:5px;">{{validationErrors.length}} Validation errors exist.  Correct errors and then validate again.  If you continue to receive validation errors contact your system administrator."</span>
                </div>
            </div>
            <div class="row mt-3" *ngIf="false == importErrorsExist && parkerSuccessResults.length > 0">
                <div class="col-10">
                    <span class="material-icons success-icon" style="position: relative; top:5px;margin-left:50px;">
                        check_circle
                    </span>
                    <span style="font-size:16px;color: green;margin-left:10px;">{{parkerSuccessResults.length}} Parker Profile(s) were submitted successfully with no errors.</span>
                </div>
            </div>
            <div class="row mt-3" *ngIf="validationErrors.length == 0 && validationCheckCompleted == true">
              
                <div class="col-10">
                    <span class="material-icons success-icon" style="position: relative; top:5px;margin-left:50px;">
                        check_circle
                    </span>
                    <span style="font-size:16px;color: green;margin-left:10px;">All {{numberOfParkersValidated}} queued Parker Profile(s) have passed the validation check with no errors.</span>
                </div>
            </div>
        </div>
            
        
           
            <igx-grid [batchEditing]="true" #gridProfile [data]="profileData" [width]="'99%'" [height]="'520px'" [autoGenerate]="false" style=margin-left:10px;
                paste-handler-standalone (onDataProcessed)="dataPasted($event)" [primaryKey]="'rowNumber'" [rowEditable]="true"  [ignoreDirective]="ignoreDirective"
                [allowFiltering]="true" filterMode="excelStyleFilter" displayDensity="compact" 
                [emptyGridMessage]="'Parker Import Has No Data'"  (rowEditDone)="RowEditFinished($event)" (rowDeleted)="RowDeleteFinished()"
                [cellSelection]="'none'"  (rowSelectionChanging)="handleRowSelection($event)" [rowSelection]="selectionMode"  (columnInit)="onColumnInit($event)"    
            >
        
                <ng-template igxRowEditActions let-endRowEdit >
                    <button igxButton igxRowEditTabStop (click)="endRowEdit(false)" style="color:black">Cancel</button>
                    <button igxButton igxRowEditTabStop (click)="endRowEdit(true)"  style="color:black">Update</button>
                </ng-template>
        
                <ng-template igxRowAddText style="color:black">
                    Adding Parker
                </ng-template>
        
          
        
               
                <igx-grid-toolbar>
                    <igx-grid-toolbar-actions>
                        <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
                        <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
                        <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
                       
                    </igx-grid-toolbar-actions>
        
                </igx-grid-toolbar>
        
                
        
                <igx-column field="companyName" header="Company Name*" [editable]="importGridEditable" [sortable]="true" width="250px" required >
                    <ng-template igxCellEditor let-cell="cell" let-value >
                        <igx-select
                        class="cell-select"
                        [(ngModel)]="cell.editValue"
                       >
                        <igx-select-item>
                            Select Company
                        </igx-select-item>
                        <igx-select-item *ngFor="let company of companyList" [value]="company.companyName" width="250px" (click)="GetRateListForCompany(cell.editValue)" (onKeyPress)="GetRateListForCompany(cell.editValue)">
                            {{ company.companyName }}
                        </igx-select-item>
                        </igx-select>
                    </ng-template>
                    <ng-template igxCell let-cell="cell" let-value>
                        <div class="cell__inner">
                            <!-- <div *ngIf="value == ''">
                                Select Company
                            </div>
                            <div *ngIf="isError(cell.row.index, 'companyName')" >
                                <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'companyName')">
                                    warning
                                </span>
                                <span style="padding-left:15px;position:relative;top:-5px;">{{value}}</span>
                            </div> -->
                            <div>
                                {{value}}
                            </div>
                        </div>
                    </ng-template>
                </igx-column>
               
                <igx-column [field]="'firstName'"  header="First Name*" [sortable]="true" required [maxlength]="32" [editable]="importGridEditable">
        
                    <ng-template igxCell let-value let-cell="cell">
                        <div class="cell__inner">
                            <!-- <div *ngIf="isError(cell.row.index, 'firstName')" >
                                <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'firstName')">
                                    warning
                                </span>
                                <span style="padding-left:15px;position:relative;top:-5px;"> {{value}}</span>
                            </div> -->
                            <div>
                                {{value}}
                            </div>
                        </div>
                    </ng-template>
        
                </igx-column>
        
                <igx-column [field]="'lastName'"  header="Last Name*" [sortable]="true"  [hidden]="false" required [maxlength]="32">
        
                    <ng-template igxCell let-value let-cell="cell">
                        <div class="cell__inner">
                            <!-- <div *ngIf="isError(cell.row.index, 'lastName')" >
                                <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'lastName')">
                                    warning
                                </span>
                                <span style="padding-left:15px;position:relative;top:-5px;"> {{value}}</span>
                            </div> -->
                            <div>
                                {{value}}
                            </div>
                        </div>
                    </ng-template>
        
                </igx-column>
        
                <igx-column [field]="'startDate'"  header="Start Date*" [dataType]="'date'" required  width="200px">
                    <ng-template igxCell let-value let-cell="cell">
                        <div class="cell__inner">
                            <!-- <div *ngIf="isError(cell.row.index, 'startDate')" >
                                <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'startDate')">
                                    warning
                                </span>
                                <span style="padding-left:15px;position:relative;top:-5px;"> {{ value | date : 'shortDate'}}</span>
                            </div> -->
                            <div>
                                {{ value | date : 'shortDate'}}
                            </div>
                        </div>
                    </ng-template>
                </igx-column>
        
                <igx-column [field]="'endDate'"  header="End Date"  [dataType]="'date'"   width="200px">        
                    <ng-template igxCell let-value let-cell="cell">
                        <div class="cell__inner">
                            <!-- <div *ngIf="isError(cell.row.index, 'endDate')" >
                                <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'endDate')">
                                    warning
                                </span>
                                <span style="padding-left:15px;position:relative;top:-5px;"> {{ value | date : 'shortDate'}}</span>
                            </div> -->
                            <div>
                                {{ value | date : 'shortDate'}}
                            </div>
                        </div>
                    </ng-template>
                </igx-column>
                
                <igx-column [field]="'rateNumber'"  header="Rate Number*" [dataType]="'number'" required>
                    <ng-template igxCellEditor let-cell="cell" let-value >
                        <igx-select
                        class="cell-select"
                        [(ngModel)]="cell.editValue"
                     
                        >
                        <igx-select-item>
                            Select Rate Number
                        </igx-select-item>
                        <igx-select-item *ngFor="let rate of marketRateList" [value]="rate.rateNumber" width="200px">
                            {{ rate.rateNumber }}
                        </igx-select-item>
                        </igx-select>
                    </ng-template>
        
                    <ng-template igxCell let-cell="cell" let-value>
                        <div class="cell__inner">

                            <!-- <div *ngIf="isError(cell.row.index, 'rateNumber')" >
                                <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'rateNumber')">
                                    warning
                                </span>
                                <span style="padding-left:15px;position:relative;top:-5px;">{{value}}</span>
                            </div> -->
                            <div>
                                {{value}}
                            </div>
                        </div>
                    </ng-template>
        
                </igx-column>
        
                <igx-column [field]="'parkerPayType'"  header="Parker Pay Type*" required  width="150px">
                    <ng-template igxCellEditor let-cell="cell" let-value >
                        <igx-select
                        class="cell-select"
                        [(ngModel)]="cell.editValue"
                       
                        >
                        <igx-select-item>
                            Select Parker Pay Type
                        </igx-select-item>
                        <igx-select-item [value]="'Parker'">
                            Parker
                        </igx-select-item>
                        <igx-select-item [value]="'Company'">
                            Company
                        </igx-select-item>
                        </igx-select>
                    </ng-template>
        
                    <ng-template igxCell let-cell="cell" let-value>
                        <div class="cell__inner">
                            <!-- <div *ngIf="isError(cell.row.index, 'parkerPayType')" >
                                <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'parkerPayType')">
                                    warning
                                </span>
                                <span style="padding-left:15px;position:relative;top:-5px;">{{value}}</span>
                            </div> -->
                            <div>
                                {{value}}
                            </div>
                        </div>
                    </ng-template>
                </igx-column>
                
                <igx-column [field]="'deliveryType'"  header="Delivery Type" required>
                    <ng-template igxCellEditor let-cell="cell" let-value >
                        <igx-select
                        class="cell-select"
                        [(ngModel)]="cell.editValue"
                       
                        >
                        <igx-select-item>
                            Select Delivery Type
                        </igx-select-item>
                        <igx-select-item [value]="'Email'">
                            Email
                        </igx-select-item>
                        <igx-select-item [value]="'Print'">
                            Print
                        </igx-select-item>
                        </igx-select>
                    </ng-template>
        
                    <ng-template igxCell let-cell="cell" let-value>
                        <div class="cell__inner">
                            <!-- <div *ngIf="isError(cell.row.index, 'deliveryType')" >
                                <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'deliveryType')">
                                    warning
                                </span>
                                <span style="padding-left:15px;position:relative;top:-5px;">{{value}}</span>
                            </div> -->
                            <div>
                                {{value}}
                            </div>
                        </div>
                    </ng-template>
                </igx-column>
        
                <igx-column [field]="'emailAddress'"  header="Email Address"  width="250px" [maxlength]="255"></igx-column>
        
                <igx-column [field]="'cardNumber'" [sortable]="true" [cellStyles]="GetStyles()"  header="Card Number" [maxlength]="16" [dataType]="'number'"></igx-column>
               
                <igx-column [field]="'stallNumber'" header="Stall Number" [maxlength]="12"></igx-column>
               
                <igx-column [field]="'billingAddress'"  header="Billing Address" [maxlength]="255"></igx-column>
               
                <igx-column [field]="'suiteNumber'"  header="Suite Number" [maxlength]="255"></igx-column>
                
                <igx-column field="city" header="City" [editable]="true" [maxlength]="32"></igx-column>
                
                <igx-column [field]="'state'"   header="State">
                    <ng-template igxCellEditor let-cell="cell" let-value >
                        <igx-select
                        class="cell-select"
                        [(ngModel)]="cell.editValue"
                      
                        >
                        <igx-select-item>
                            Select State
                        </igx-select-item>
                        <igx-select-item *ngFor="let state of stateList" [value]="state.stateAbbreviation" width="250px">
                            {{ state.stateAbbreviation }}
                        </igx-select-item>
                        </igx-select>
                    </ng-template>
                </igx-column>
        
                <igx-column [field]="'zip'"  header="Zip Code" [maxlength]="12">
        
                </igx-column>
        
                <igx-column [field]="'phoneNumber'"  header="Phone Number" [maxlength]="12"></igx-column>
              
                <igx-column [field]="'vehicleLicense'"  header="Vehicle License" [maxlength]="32"></igx-column>
                
                <igx-column [field]="'vehicleMake'"  header="Vehicle Make" [maxlength]="32"></igx-column>
                
                <igx-column [field]="'vehicleModel'"  header="Vehicle Model" [maxlength]="32"></igx-column>
                
                <igx-column [field]="'vehicleColor'"  header="Vehicle Color" [maxlength]="16"></igx-column>
                
                <igx-column [field]="'vehicleState'"  header="Vehicle State" >
                    <ng-template igxCellEditor let-cell="cell" let-value >
                        <igx-select
                        class="cell-select"
                        [(ngModel)]="cell.editValue"
                      
                        >
                        <igx-select-item>
                            Select State
                        </igx-select-item>
                        <igx-select-item *ngFor="let state of stateList" [value]="state.stateAbbreviation" width="250px">
                            {{ state.stateAbbreviation }}
                        </igx-select-item>
                        </igx-select>
                    </ng-template>
                </igx-column>
                
                <igx-column [field]="'comments'"  header="Comments" [maxlength]="2048"></igx-column>

                <div *ngIf="enablePasteMode == false">
                    <igx-column [field]="'status'"  header="Status" [sortable]="true" [hidden]="false" dataType="number">
                        <ng-template igxCell let-cell="cell">
                            <div class="cell__inner">
        
                                <div *ngIf="cell.value == 0 || cell.value == ''">
                                    <span>Queued</span>
                                </div>
                                <div *ngIf="cell.value == 1">
                                    <span>Validated</span>
                                </div>
                                <div *ngIf="cell.value == 2">
                                    <span class="material-icons error-icon">
                                        warning
                                    </span>
                                </div>
                                <div *ngIf="cell.value == 3">
                                    <span>Saved</span>
                                </div>
                            </div>
                        </ng-template>
                    </igx-column>
                </div>

                <igx-column [field]="'rowNumber'"  [dataType]="'number'"></igx-column>
                
                <igx-action-strip #actionstrip>
                    <igx-grid-editing-actions [addRow]="true"></igx-grid-editing-actions>
                </igx-action-strip>
            </igx-grid>
        
    </mat-tab>

    <!-- Import Results -->
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="example-tab-icon mr-2">people</mat-icon>
            <span style="margin-left: 5px">
                Profiles Submitted ({{parkerSuccessResults.length}})
            </span>
        </ng-template>

        <div class="grid__wrapper" style="margin-top:30px;">
            <!-- <div class="grid__menu">
                <button igxButton="raised" [igxToggleAction]="dropdown" [igxDropDownItemNavigation]="dropdown">Paste Options</button>
                <igx-drop-down #dropdown (selectionChanging)="selectionChange($event)" >
                    <igx-drop-down-item *ngFor="let item of comboData" [value]="item" >
                        {{ item }}
                    </igx-drop-down-item>
                </igx-drop-down>
                <button id="download_excel" igxButton="raised" (click)="downloadExcel($event)">Download Sample Excel File</button>
            </div> -->

            <div *ngIf="parkerImportResults.length == 0">
                No import results
            </div>
            <div *ngIf="parkerImportResults.length > 0">
                <igx-grid [batchEditing]="false" #gridProfileResults [data]="parkerSuccessResults" [width]="'100%'" [height]="'600px'" [autoGenerate]="false" 
                    [primaryKey]="'rowNumber'" [rowEditable]="true"
                    [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact" [moving]="true">
            
            
                    <igx-paginator [perPage]="25"></igx-paginator>
                    <igx-grid-toolbar>
                        <igx-grid-toolbar-actions>
                            <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
                            <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
                            <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter>
                        
                        </igx-grid-toolbar-actions>
            
                    </igx-grid-toolbar>
            
                    <igx-column [field]="'rowNumber'"  [hidden]="true"></igx-column>
                    
            
                    <div *ngIf="enablePasteMode">
                        <igx-column [field]="'status'"  header="Status" [sortable]="true" [hidden]="false" dataType="number">
                            <ng-template igxCell let-cell="cell">
                                <div class="cell__inner">
            
                                    <div *ngIf="cell.value == 0 || cell.value == ''">
                                        <span>Queued</span>
                                    </div>
                                    <div *ngIf="cell.value == 1">
                                        <span>Validated</span>
                                    </div>
                                    <div *ngIf="cell.value == 2">
                                        <!-- <span>Validation Error</span> -->
                                        <span class="material-icons error-icon">
                                            warning
                                        </span>
                                    </div>
                                    <div *ngIf="cell.value == 3">
                                        <span>Saved</span>
                                    </div>
                                </div>
                            </ng-template>
                        </igx-column>
                        
                    </div>
            
                    <igx-column field="companyName" header="Company Name" [editable]="true" [sortable]="true" width="250px" required >
                        <ng-template igxCellEditor let-cell="cell" let-value >
                            <igx-select
                            class="cell-select"
                            [(ngModel)]="cell.editValue"
                            >
                            <igx-select-item *ngFor="let company of companyList" [value]="company.companyName" width="250px" (click)="GetRateListForCompany(cell.editValue)" (onKeyPress)="GetRateListForCompany(cell.editValue)">
                                {{ company.companyName }}
                            </igx-select-item>
                            </igx-select>
                        </ng-template>
                        <ng-template igxCell let-cell="cell" let-value>
                            <div class="cell__inner">
                                <div *ngIf="isError(cell.row.index, 'companyName')" >
                                    <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'companyName')">
                                        warning
                                    </span>
                                    <span style="padding-left:15px;position:relative;top:-5px;">{{value}}</span>
                                </div>
                                <div *ngIf="!isError(cell.row.index, 'companyName')">
                                    {{value}}
                                </div>
                            </div>
                        </ng-template>
                    </igx-column>
                
                    <igx-column [field]="'firstName'"  header="First Name" [sortable]="true" required [maxlength]="32">
            
                        <ng-template igxCell let-value let-cell="cell">
                            <div class="cell__inner">
                                <div *ngIf="isError(cell.row.index, 'firstName')" >
                                    <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'firstName')">
                                        warning
                                    </span>
                                    <span style="padding-left:15px;position:relative;top:-5px;"> {{value}}</span>
                                </div>
                                <div *ngIf="!isError(cell.row.index, 'firstName')">
                                    {{value}}
                                </div>
                            </div>
                        </ng-template>
            
                    </igx-column>
            
                    <igx-column [field]="'lastName'"  header="Last Name" [sortable]="true"  [hidden]="false" required [maxlength]="32">
            
                        <ng-template igxCell let-value let-cell="cell">
                            <div class="cell__inner">
                                <div *ngIf="isError(cell.row.index, 'lastName')" >
                                    <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'lastName')">
                                        warning
                                    </span>
                                    <span style="padding-left:15px;position:relative;top:-5px;"> {{value}}</span>
                                </div>
                                <div *ngIf="!isError(cell.row.index, 'lastName')">
                                    {{value}}
                                </div>
                            </div>
                        </ng-template>
            
                    </igx-column>
            
                    <igx-column [field]="'startDate'"  header="Start Date" [dataType]="'date'" required >
                        <ng-template igxCell let-value let-cell="cell">
                            <div class="cell__inner">
                                <div *ngIf="isError(cell.row.index, 'startDate')" >
                                    <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'startDate')">
                                        warning
                                    </span>
                                    <span style="padding-left:15px;position:relative;top:-5px;"> {{ value | date : 'shortDate'}}</span>
                                </div>
                                <div *ngIf="!isError(cell.row.index, 'startDate')">
                                    {{ value | date : 'shortDate'}}
                                </div>
                            </div>
                        </ng-template>
                    </igx-column>
            
                    <igx-column [field]="'endDate'"  header="End Date"  [dataType]="'date'">        
                        <ng-template igxCell let-value>
                            <div class="cell__inner">
                                <div *ngIf="value == '1/1/0001'">
                                  
                                </div>
                                <div *ngIf="value != '1/1/0001'">
                                    {{ value | date : 'shortDate'}}
                                </div>
                            </div>
                        </ng-template>
                    </igx-column>
                    
                    <igx-column [field]="'rateNumber'"  header="Rate Number" [dataType]="'number'" required>
                        <ng-template igxCellEditor let-cell="cell" let-value >
                            <igx-select
                            class="cell-select"
                            [(ngModel)]="cell.editValue"
                            
                            >
                            <igx-select-item *ngFor="let rate of marketRateList" [value]="rate.rateNumber" width="200px">
                                {{ rate.rateNumber }}
                            </igx-select-item>
                            </igx-select>
                        </ng-template>
            
                        <ng-template igxCell let-cell="cell" let-value>
                            <div class="cell__inner">
                                <div *ngIf="isError(cell.row.index, 'rateNumber')" >
                                    <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'rateNumber')">
                                        warning
                                    </span>
                                    <span style="padding-left:15px;position:relative;top:-5px;">{{value}}</span>
                                </div>
                                <div *ngIf="!isError(cell.row.index, 'rateNumber')">
                                    {{value}}
                                </div>
                            </div>
                        </ng-template>
            
                    </igx-column>
            
                    <igx-column [field]="'parkerPayType'"  header="Parker Pay Type" required  width="150px">
                        <ng-template igxCellEditor let-cell="cell" let-value >
                            <igx-select
                            class="cell-select"
                            [(ngModel)]="cell.editValue"
                          
                            >
                            <igx-select-item [value]="'Parker'">
                                Parker
                            </igx-select-item>
                            <igx-select-item [value]="'Company'">
                                Company
                            </igx-select-item>
                            </igx-select>
                        </ng-template>
            
                        <ng-template igxCell let-cell="cell" let-value>
                            <div class="cell__inner">
                                <div *ngIf="isError(cell.row.index, 'parkerPayType')" >
                                    <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'parkerPayType')">
                                        warning
                                    </span>
                                    <span style="padding-left:15px;position:relative;top:-5px;">{{value}}</span>
                                </div>
                                <div *ngIf="!isError(cell.row.index, 'parkerPayType')">
                                    {{value}}
                                </div>
                            </div>
                        </ng-template>
                    </igx-column>
                    
                    <igx-column [field]="'deliveryType'"  header="Delivery Type" required>
                        <ng-template igxCellEditor let-cell="cell" let-value >
                            <igx-select
                            class="cell-select"
                            [(ngModel)]="cell.editValue"
                           
                            >
                            <igx-select-item [value]="'Email'">
                                Email
                            </igx-select-item>
                            <igx-select-item [value]="'Print'">
                                Print
                            </igx-select-item>
                            </igx-select>
                        </ng-template>
            
                        <ng-template igxCell let-cell="cell" let-value>
                            <div class="cell__inner">
                                <div *ngIf="isError(cell.row.index, 'deliveryType')" >
                                    <span class="material-icons error-icon mr-2" [matTooltip]="ValidationErrorToolTip(cell.row.index, 'deliveryType')">
                                        warning
                                    </span>
                                    <span style="padding-left:15px;position:relative;top:-5px;">{{value}}</span>
                                </div>
                                <div *ngIf="!isError(cell.row.index, 'deliveryType')">
                                    {{value}}
                                </div>
                            </div>
                        </ng-template>
                    </igx-column>
            
                    <igx-column [field]="'emailAddress'"  header="Email Address"  width="250px" [maxlength]="255"></igx-column>
            
                    <igx-column [field]="'cardNumber'" [sortable]="true" [cellStyles]="GetStyles()"  header="Card Number" [maxlength]="16"></igx-column>
                
                    <igx-column [field]="'stallNumber'" header="Stall Number" [maxlength]="12"></igx-column>
                
                    <igx-column [field]="'billingAddress'"  header="Billing Address" [maxlength]="255"></igx-column>
                
                    <igx-column [field]="'suiteNumber'"  header="Suite Number" [maxlength]="255"></igx-column>
                    
                    <igx-column field="city" header="City" [editable]="true" [maxlength]="32"></igx-column>
                    
                    <igx-column [field]="'state'"   header="State">
                        <ng-template igxCellEditor let-cell="cell" let-value >
                            <igx-select
                            class="cell-select"
                            [(ngModel)]="cell.editValue"
                           
                            >
                            <igx-select-item *ngFor="let state of stateList" [value]="state.stateAbbreviation" width="250px">
                                {{ state.stateAbbreviation }}
                            </igx-select-item>
                            </igx-select>
                        </ng-template>
                    </igx-column>
            
                    <igx-column [field]="'zip'"  header="Zip Code" [maxlength]="12">
            
                    </igx-column>
            
                    <igx-column [field]="'phoneNumber'"  header="Phone Number" [maxlength]="12"></igx-column>
                
                    <igx-column [field]="'vehicleLicense'"  header="Vehicle License" [maxlength]="32"></igx-column>
                    
                    <igx-column [field]="'vehicleMake'"  header="Vehicle Make" [maxlength]="32"></igx-column>
                    
                    <igx-column [field]="'vehicleModel'"  header="Vehicle Model" [maxlength]="32"></igx-column>
                    
                    <igx-column [field]="'vehicleColor'"  header="Vehicle Color" [maxlength]="16"></igx-column>
                    
                    <igx-column [field]="'vehicleState'"  header="Vehicle State" >
                        <ng-template igxCellEditor let-cell="cell" let-value >
                            <igx-select
                            class="cell-select"
                            [(ngModel)]="cell.editValue"
                           
                            >
                            <igx-select-item *ngFor="let state of stateList" [value]="state.stateAbbreviation" width="250px">
                                {{ state.stateAbbreviation }}
                            </igx-select-item>
                            </igx-select>
                        </ng-template>
                    </igx-column>
                    
                    <igx-column [field]="'comments'"  header="Comments" [maxlength]="2048"></igx-column>
       
                </igx-grid>
            </div>
        </div>

    </mat-tab>



